import "./featured.scss";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { CircularProgressbar } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";

const Featured = ({
  type,
  totalYearlyRevenue,
  totalVisitors,
  totalVisitorRevenue,
  monthToday,
  adminTypes,
  yearToday,
}) => {
  const progress = Math.round((monthToday / 12) * 100);
  if (adminTypes === "sAdmin") {
    totalYearlyRevenue = 0;
  }
  return type === "revenue" ? (
    <div className="featured">
      <div className="top">
        <h1 className="title">Revenue Status Year :{yearToday}</h1>
        <MoreVertIcon fontSize="small" />
      </div>
      <div className="bottom">
        <div className="featuredChart">
          <CircularProgressbar
            value={progress}
            text={`${progress}%`}
            strokeWidth={5}
          />
        </div>
        <p className="title">Total Balance till now</p>
        <p className="amount">Rs.{totalYearlyRevenue}</p>
      </div>
    </div>
  ) : (
    <div className="featured">
      <div className="top">
        <h1 className="title">Visitor Revenue Status :{yearToday}</h1>
        <MoreVertIcon fontSize="small" />
      </div>
      <div className="bottom">
        <div className="featuredChart">
          <CircularProgressbar
            value={progress}
            text={`${progress}%`}
            strokeWidth={5}
          />
        </div>
        <p className="title">Total Visitors : {totalVisitors}</p>
        <p className="amountVisitor">Rs.{totalVisitorRevenue} </p>
        <p className="desc">Will be paid at the end of this year </p>
      </div>
    </div>
  );
};

export default Featured;
